/** @format */
import * as EmailValidator from 'email-validator';

export const rules = {
	required: [
		{
			required: true,
			message: 'Este campo es requerido de forma obligatoria',
		},
	],
	alphanumeric: [
		{
			required: true,
			message: 'Este campo es requerido de forma obligatoria',
		},
		{
			validator: (_, value) => {
				if (!value) return Promise.resolve();
				if (/^[a-zA-Z0-9-]+$/.test(value)) {
					return Promise.resolve();
				}
				return Promise.reject('Solo se permiten letras, números y guiones medios (-)');
			},
		},
	],
	phone: [
		{
			required: true,
			message: 'Este campo es requerido de forma obligatoria',
		},
		{
			validator: (_, value) => {
				if (value && value.length >= 8 && value.length <= 13) {
					return Promise.resolve();
				}
				return Promise.reject('El teléfono debe tener entre 8 y 13 caracteres');
			},
		},
	],
	geoloc_lat: [
		{
			required: true,
			message: 'Ingrese una dirección',
		},
		{
			validator: (rule, value) => {
				if (value > -90 && value < 90) {
					return Promise.resolve();
				}
				return Promise.reject(`Latitud debe estar entre -90 y 90`);
			},
		},
	],
	geoloc_lng: [
		{
			required: true,
			message: 'Ingrese una dirección',
		},
		{
			validator: (rule, value) => {
				if (value > -180 && value < 180) {
					return Promise.resolve();
				}
				return Promise.reject(`Longitud debe estar entre -180 y 180`);
			},
		},
	],
	email: [
		{
			required: true,
			message: 'Porfavor ingresa tu Correo',
		},
		{
			validator: (_, value) => {
				if (EmailValidator.validate(value) === true) {
					return Promise.resolve();
				}
				return Promise.reject('Email inválido');
			},
		},
	],
};
